import { Navigate } from 'react-router-dom';
import { Ellie } from '../components/Ellie';
import { useFeatureFlag } from '../services/featureFlag.service';
import FeatureFlagService from '../services/featureFlag.service';
import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import elliePng from '../assets/images/pliable/ellie.png';
import PageTitle from '../components/PageTitle';

export default function ElliePage() {
  const isAiAssistantEnabled = useFeatureFlag('ai-assistant', false);
  const [flagsReady, setFlagsReady] = useState(() => FeatureFlagService.getInstance().isReady);
  const isEmbedded =
    typeof window !== 'undefined' && window.location.pathname === '/embed';

  useEffect(() => {
    if (flagsReady) return;
    FeatureFlagService.getInstance().waitForInitialization().then(() => setFlagsReady(true));
  }, [flagsReady]);

  if (!flagsReady) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAiAssistantEnabled) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border flex items-center gap-3">
        <img src={elliePng} alt="Ellie" className="h-10 w-10 rounded-full object-cover" />
        <div>
          <PageTitle title="Hi, I'm Ellie" />
          <p className="text-sm text-muted-foreground">Your AI chief of staff — ask me about your business and get recommendations on how to change your strategy.</p>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {isEmbedded ? (
          <div className="h-full w-3/4 mx-auto">
            <Ellie showHistory={false} />
          </div>
        ) : (
          <Ellie showHistory={true} />
        )}
      </div>
    </div>
  );
}
